import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../../modules/auth/services/auth.service';

export const SetPasswordGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const messageService = inject(MessageService);
  const token = route.params['token'] || '';

  if (!token) {
    router.navigate(['/auth/login']);
    messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'No access Token found',
    });

    return of(false);
  }

  return authService.setTokenVerify(token).pipe(
    map(() => true),
    catchError((err) => {
      console.error('Verify API error:', err);
      router.navigate(['/auth/login']);
      return of(false);
    }),
  );
};
